import FeaturedPost from './featuredPost';

export default FeaturedPost;
